import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography
} from '@mui/material';

import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

import { useClientZS } from '../../../pages/ClientZS';

export const NotificationsCard = () => {
  const { orderData } = useClientZS();

  if (!orderData) {
    return null;
  }

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <CampaignOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Zgody marketingowe
          </Typography>
        </Stack>

        <Typography
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          Aktualnie udzielone zgody marketingowe.
        </Typography>

        <Stack spacing={1}>
          <Box />
          <FormControlLabel
            disabled
            control={
              <Checkbox
                checked={
                  orderData.marketing_consents_email
                }
              />
            }
            label="Kontakt e-mail"
          />

          <FormControlLabel
            disabled
            control={
              <Checkbox
                checked={
                  orderData.marketing_consents_sms
                }
              />
            }
            label="Kontakt SMS"
          />

          <FormControlLabel
            disabled
            control={
              <Checkbox
                checked={
                  orderData.marketing_consents_phone
                }
              />
            }
            label="Kontakt telefoniczny"
          />

          <FormControlLabel
            disabled
            control={
              <Checkbox
                checked={
                  orderData.marketing_consents_survey
                }
              />
            }
            label="Ankiety i badania satysfakcji"
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
